import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import React from 'react';
import { Typography } from '@mui/material';
import PropTypes from 'prop-types';

/** @component
 * Renders the header text on the app page for both desktop and mobile.
 * @param id {String}
 * @param role {String}
 * @returns {Element}
 * @constructor
 */
export const AppPageHeaderText = ({ id, role }) => {
    const theme = useTheme();
    const isBelowSm = useMediaQuery(theme.breakpoints.down('sm'));

    if (isBelowSm) {
        return (
            <Typography
                id={id}
                role={role}
                component='h1'
                variant='headerMobile'
                data-analyticsid='header'
            >
                <>
                    Essentia Behavioral
                    <br />
                    Alpha® Benchmark
                    <br />
                </>
            </Typography>
        );
    } else {
        return (
            <Typography
                id={id}
                role={role}
                component='h1'
                variant='header1'
                data-analyticsid='sub-header'
            >
                Essentia Behavioral Alpha® Benchmark
            </Typography>
        );
    }
};

AppPageHeaderText.propTypes = {
    id: PropTypes.string,
    role: PropTypes.string
};

export default AppPageHeaderText;
